/**
 * 接口域名的管理
 */
const base = {
  sq: 'http://dj.admin.scxyjnet.com/api', //线上
  // sq: 'http://10.8.8.121:8000/api' //本地
}

export default base;
